import React from 'react'

const CRMStats = () => {
  return (
    <div>CRMStats</div>
  )
}

export default CRMStats